export default __webpack_public_path__ + "53dfd469a087a0eee1c6f4ba46476c02.png";